import React, { Component } from 'react';

const withDrawerState = (ComponentWithDrawer) => class WithDrawerState
  extends Component {
  constructor() {
    super();

    this.state = {
      open: false,
    };
  }

  onOpenDrawer = () => this.setState((previousState) => ({
    open: !previousState.open,
  }));

  onCloseDrawer = () => this.setState({
    open: false,
  });

  render() {
    return (
      <ComponentWithDrawer
        {...this.state}
        {...this.props}
        onOpenDrawer={this.onOpenDrawer}
        onCloseDrawer={this.onCloseDrawer}
      />
    );
  }
};

export default withDrawerState;
